import { Link } from "office-ui-fabric-react"

const AzureADUsersSyncSettingsTooltip = () => {
    return <div>
        Configure sync between Azure Active Directory and PPM Express Users.
        <br />
        Please refer to the <Link href="https://help.ppm.express/89495-ppm-express-settings/522610" target="_blank">article</Link> for more details.
    </div>
}

export default AzureADUsersSyncSettingsTooltip;